import {SEARCH_FOOTPRINTS, BACKLINK_CATEGORIES} from '../config/api'

export class TavilyService {
  static async searchBacklinks(keyword, onProgress) {
    const results = []
    let completedSearches = 0

    for (const footprint of SEARCH_FOOTPRINTS) {
      try {
        // Special handling for the niche collaborations search
        let query = '';
        if (footprint === 'niche collaboration') {
          query = `intitle:${keyword} + "blog"`;
        } else {
          query = footprint === 'best of' ? `best of ${keyword}` : `${keyword} "${footprint}"`;
        }

        // Define excluded domains based on footprint
        let excludeDomains = []
        if (footprint === 'niche collaboration') {
          excludeDomains = [
            'indeed.com', 'linkedin.com', 'facebook.com', 'twitter.com', 'pinterest.com',
            'google.com', 'amazon.com', 'youtube.com', 'x.com', 'reddit.com',
            'instagram.com', 'glassdoor.com'
          ]
        } else if (footprint === 'write for us') {
          excludeDomains = [
            'indeed.com', 'linkedin.com', 'facebook.com', 'twitter.com', 'pinterest.com',
            'google.com', 'amazon.com', 'youtube.com', 'x.com', 'reddit.com',
            'instagram.com', 'glassdoor.com'
          ]
        } else if (footprint === 'leave a reply') {
          excludeDomains = ['scribd.com', 'wpdiscuz.com']
        } else if (footprint === 'resources') {
          excludeDomains = [
            'indeed.com', 'linkedin.com', 'facebook.com', 'twitter.com', 'pinterest.com',
            'google.com', 'amazon.com', 'youtube.com', 'x.com', 'reddit.com',
            'instagram.com', 'glassdoor.com'
          ]
        }

        const response = await fetch('/.netlify/functions/tavilyProxy', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query: query,
            search_depth: 'basic',
            include_answer: false,
            include_domains: [],
            exclude_domains: excludeDomains,
            max_results: 20
          })
        })

        if (!response.ok) {
          throw new Error(`Tavily API error: ${response.status}`)
        }

        const data = await response.json()
        if (data.results) {
          const categorizedResults = data.results.map(result => ({
            ...result,
            category: BACKLINK_CATEGORIES[footprint] || 'Other',
            footprint: footprint,
            keyword: keyword
          }))
          results.push(...categorizedResults)
        }

        completedSearches++
        onProgress((completedSearches / SEARCH_FOOTPRINTS.length) * 100)

        // Add delay to avoid rate limiting
        await new Promise(resolve => setTimeout(resolve, 500))
      } catch (error) {
        console.error(`Error searching for ${footprint}:`, error)
        completedSearches++
        onProgress((completedSearches / SEARCH_FOOTPRINTS.length) * 100)
      }
    }

    return results
  }

  static async searchCustomFootprint(customQuery, onProgress) {
    try {
      const response = await fetch('/.netlify/functions/tavilyProxy', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: customQuery,
          search_depth: 'basic',
          include_answer: false,
          include_domains: [],
          exclude_domains: [],
          max_results: 20
        })
      })

      if (!response.ok) {
        throw new Error(`Tavily API error: ${response.status}`)
      }

      const data = await response.json()
      onProgress(100)
      if (!data.results) return []

      return data.results.map(result => ({
        ...result,
        category: 'Custom Results',
        footprint: 'custom',
        keyword: customQuery
      }))
    } catch (error) {
      console.error('Error performing custom footprint search:', error)
      onProgress(100)
      return []
    }
  }
}
